import { render, staticRenderFns } from "./sectionCardImage.vue?vue&type=template&id=221b9ce4&scoped=true"
import script from "./sectionCardImage.vue?vue&type=script&lang=js"
export * from "./sectionCardImage.vue?vue&type=script&lang=js"
import style0 from "./sectionCardImage.vue?vue&type=style&index=0&id=221b9ce4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221b9ce4",
  null
  
)

export default component.exports